<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>配货订单核算总&nbsp;&nbsp;说明:</h5><br>
				<span
					class="red">1、单号类型:YS=运输单、YF=运费申请单、PS=个人报销单、JK=个人借款单、SJ=司机费用报销、ZB=增补费、JW=就位费、BX=保险费、KL=看路费。</span><br>
				<span>2、按订单号 进行分类划分。</span><br>
				<span>3、杂费=现金消费-过路费-维修费-现金购油-现金够尿素</span><br>
				<span>4、利润=运费全价-垫付-办证-护送-信息费-消费合计-尿素-油卡消费</span><br>
				<span>5、查询关键字:</span><br>
				<!-- <span>查询:标题</span><br> -->
			</div>
		</div>
		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->

				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>
			<div class="content_edit_item" v-show="file_show">
				<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
			</div>
		</div>

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[0].val" :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')"
					@dblclick="edit_data">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='imageList'">
							<ul>
								<li v-for="(t,id) in d.val" :index="id">
									<button @click="fun_show_detail(t)">{{t.f_name}}</button>
								</li>
							</ul>
						</div>
						{{d.val}}
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 弹窗编辑 大订单start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_auto_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item" v-show="show_btn">
								<pre-button @button-event="select_method" :pre_control="control" />&nbsp;&nbsp;
								<button @click="look_list_sheetm">关联运单</button>

							</div>
							<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div>
						</div>
						<!-- 这里放主单据编辑内容-->
						<div id="big_order_body" class="content_edit big-order-body">
							<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
								<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
									:key="index">
									<!-- {{handleImportView(item)}} -->

									<component :is="NextTickName(item.type)" :inData="checkJson(item)"
										@com-event="refresh_view_edit">
									</component>
								</div>
							</div>

							<div class="content_edit" v-show="file_show && show_FileMain">
								<div class="content_edit_item">
									<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
								</div>
							</div>

						</div>

					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->

		<!-- 调度列表 start -->
		<div v-show="show_sheet_list" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_auto_conten pre_auto_sheet_m">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">


					<h5>订单:{{order_no}}相关调度单列表</h5>
					<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
						<tr class="tab_header_new">
							<td>序号</td>
							<td>调度单号</td>
							<td>货名</td>
							<td>车牌</td>
							<td>司机</td>
							<td>司机电话</td>
							<td>总运费</td>
							<td>油卡</td>
							<td>现金</td>
							<td>剩余现金</td>
							<td>剩余油</td>
							<td>状态</td>
							<td>备注</td>
							<td>录入人</td>
							<td>更新时间</td>
						</tr>
						<tr :id="'sheet_m_'+data_tr.row_num" v-for="data_tr in list_sheet_m"
							@click="fun_sel_sheetno(data_tr)">
							<td>{{data_tr.row_num}}</td>
							<td>{{data_tr.sheet_no}}</td>
							<td>{{data_tr.d_name}}</td>
							<td>{{data_tr.car_no}}</td>
							<td>{{data_tr.driver}}</td>
							<td>{{data_tr.phone}}</td>
							<td>{{data_tr.amount}}</td>
							<td>{{data_tr.y_amount}}</td>
							<td>{{data_tr.xj_amount}}</td>
							<td>{{data_tr.last_xj}}</td>
							<td>{{data_tr.last_y}}</td>
							<td>{{data_tr.flag}}</td>
							<td>{{data_tr.note}}</td>
							<td>{{data_tr.u_name}}</td>
							<td>{{data_tr.sys_date}}</td>
						</tr>
					</table>



					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<div v-show="show_order_detail" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_auto_conten pre_auto_order_d">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeorderdetail" />
				</span>
				<div class="pre_upload">
					<h5>订单:{{order_no}}相关单项费用明细</h5>
					<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
						<tr class="tab_header_new">
							<td>序号</td>
							<td>业务单号</td>
							<td>费用名称</td>
							<td>支付日期</td>
							<td>卡号</td>
							<td>金额</td>
							<td>收入|支出</td>
							<td>备注</td>
							<td>收款人</td>
							<td>收款账号</td>
							<td>更新时间</td>
						</tr>
						<tr v-for="data_tr in list_child_detail">
							<td>{{data_tr.row_num}}</td>
							<td>{{data_tr.sheet_no}}</td>
							<td>{{data_tr.pay_name}}</td>
							<td>{{data_tr.pay_date}}</td>
							<td>{{data_tr.pay_no}}</td>
							<td>{{data_tr.pay_amount}}</td>
							<td>{{data_tr.pay_io}}</td>
							<td v-on:mousemove="show_detaildata($event, data_tr.pay_note, '1')"
								v-on:mouseout="noshow_detaildata">{{data_tr.pay_note}}</td>
							<td>{{data_tr.rec_user}}</td>
							<td>{{data_tr.rec_card}}</td>
							<td>{{data_tr.sys_date}}</td>
						</tr>
					</table>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>
		<!-- 调度列表 end -->


		<!-- 弹窗编辑 调度单列表start -->
		<!-- <pretan ref="listsheet">
			<template slot="tancontent">
				<div class="pre_auto_sheet_m">
					<div class="pre_upload">
						<h5>订单:{{order_no}}相关调度单列表</h5>
						<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
							<tr class="tab_header_new">
								<td>序号</td>
								<td>调度单号</td>
								<td>货名</td>
								<td>车牌</td>
								<td>司机</td>
								<td>司机电话</td>
								<td>总运费</td>
								<td>油卡</td>
								<td>现金</td>
								<td>未付现金</td>
								<td>未付油</td>
								<td>状态</td>
								<td>备注</td>
								<td>录入人</td>
								<td>更新时间</td>
							</tr>
							<tr :id="'sheet_m_'+data_tr.row_num" v-for="data_tr in list_sheet_m"
								@click="fun_sel_sheetno(data_tr)">
								<td>{{data_tr.row_num}}</td>
								<td>{{data_tr.sheet_no}}</td>
								<td>{{data_tr.d_name}}</td>
								<td>{{data_tr.car_no}}</td>
								<td>{{data_tr.driver}}</td>
								<td>{{data_tr.phone}}</td>
								<td>{{data_tr.amount}}</td>
								<td>{{data_tr.y_amount}}</td>
								<td>{{data_tr.xj_amount}}</td>
								<td>{{data_tr.last_xj}}</td>
								<td>{{data_tr.last_y}}</td>
								<td>{{data_tr.flag}}</td>
								<td>{{data_tr.note}}</td>
								<td>{{data_tr.u_name}}</td>
								<td>{{data_tr.sys_date}}</td>
							</tr>
						</table>
					</div>
				</div>
			</template>
		</pretan> -->

		<!-- <pretan ref="orderdetail">
			<template slot="tancontent">
				<h5>订单:{{order_no}}相关单项费用明细</h5>
				<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
					<tr class="tab_header_new">
						<td>序号</td>
						<td>业务单号</td>
						<td>费用名称</td>
						<td>支付日期</td>
						<td>卡号</td>
						<td>金额</td>
						<td>收入|支出</td>
						<td>备注</td>
						<td>收款人</td>
						<td>收款账号</td>
						<td>更新时间</td>
					</tr>
					<tr v-for="data_tr in list_child_detail">
						<td>{{data_tr.row_num}}</td>
						<td>{{data_tr.sheet_no}}</td>
						<td>{{data_tr.pay_name}}</td>
						<td>{{data_tr.pay_date}}</td>
						<td>{{data_tr.pay_no}}</td>
						<td>{{data_tr.pay_amount}}</td>
						<td>{{data_tr.pay_io}}</td>
						<td v-on:mousemove="show_detaildata($event, data_tr.pay_note, '1')"
							v-on:mouseout="noshow_detaildata">{{data_tr.pay_note}}</td>
						<td>{{data_tr.rec_user}}</td>
						<td>{{data_tr.rec_card}}</td>
						<td>{{data_tr.sys_date}}</td>
					</tr>
				</table>
			</template>
		</pretan> -->

		<!-- 弹窗编辑 end -->

		<!-- 弹窗编辑 调度单详细start -->
		<div v-show="show_child_d" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_auto_child_d child-sheet-no">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshowchildd()" />
				</span>
				<div class="pre_upload">
					<h5>调度单:{{child_sheet_no}}相关明细</h5>
					<div class="content_edit_item">
						<button @click="check_sheetm('_check')">运单检查</button>
					</div>
					<div class="content_edit big-order-body">
						<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
							<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in list_child_d"
								:key="index">
								<!-- {{handleImportView(item)}} -->

								<component :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_child">
								</component>
							</div>
						</div>
					</div>


				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->


		<!-- 弹窗编辑 调度单单个字段明细start -->
		<div v-show="show_child_detail" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_auto_sheet_detail">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshowchilddetail()" />
				</span>
				<div class="pre_upload">
					<h5>业务单:{{child_sheet_no}}相关单项费用明细</h5>
					<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
						<tr class="tab_header_new">
							<td>序号</td>
							<td>业务单号</td>
							<td>费用名称</td>
							<td>支付日期</td>
							<td>卡号</td>
							<td>金额</td>
							<td>收入|支出</td>
							<td>备注</td>
							<td>收款人</td>
							<td>收款账号</td>
							<td>更新时间</td>
						</tr>
						<tr v-for="data_tr in list_child_detail">
							<!-- <td>{{data_tr.id}}</td> -->
							<td>{{data_tr.row_num}}</td>
							<td>{{data_tr.sheet_no}}</td>
							<td>{{data_tr.pay_name}}</td>
							<td>{{data_tr.pay_date}}</td>
							<td>{{data_tr.pay_no}}</td>
							<td>{{data_tr.pay_amount}}</td>
							<td>{{data_tr.pay_io}}</td>
							<td>{{data_tr.pay_note}}</td>
							<td>{{data_tr.rec_user}}</td>
							<td>{{data_tr.rec_card}}</td>
							<td>{{data_tr.sys_date}}</td>
						</tr>
					</table>


				</div>
			</div>

		</div>
		<!-- 弹窗编辑 end -->

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_CommonLong,
		Method_CommonLongLong,
		Method_EasySelect,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		ReplaceAll
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	export default {
		name: "pre_base_table_new",
		components: {
			"pre-button": () => import("../per_mode/pre_btn_easy.vue"),
			"pre-btn-Excel": () => import("../per_old/pre_btn_control_Excel.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',
				// 弹窗编辑
				show_tan: false,

				// 明细部分参数
				show_d: false,
				show_d_edit: true,

				d_btn_more: false,
				d_btn_del: true,
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				// 备注
				detail_data: '',
				//文件
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',
				// swich 开关
				show_in: true,
				show_out: false,

				// 自定义组件 流程
				show_step: '0',
				show_stepdata: '',
				pass_step: "0",
				show_step_btn: false,

				// checkbox 组件
				isIndeterminate: true,
				show_note: false,

				max_row: [],
				// 主单据附件判断
				isFileMain: 0,
				show_FileMain: false,
				show_FileChildren: true,

				// 定义默认样式
				isTwo: '0',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',
				DTwoNone: "dlast-two-none",

				tab_data: {},
				detail_excelup: false,

				order_no: '',
				list_sheet_m: [],
				show_child_d: false,
				child_sheet_no: [],
				list_child_d: [],
				show_child_detail: false,
				list_child_detail: [],

				show_edit_str: '',

				show_sheet_list: false,
				show_sheetone: false,
				show_order_detail: false,

			};
		},
		watch: {
			d_sel_action(val) {
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.show_d = true;
				} else {
					this.show_d = false;
				}
			},
			sheet_flag(val) {
				if (val == '已提交') {
					// this.show_btn = false;
					this.show_d_edit = false;
				} else {
					// this.show_btn = true;
					this.show_d_edit = true;
				}
			},
			show_in(val) {
				console.log('==' + val);
				if (val) {
					this.show_out = false;
				} else {
					this.show_out = true;
				}
			},
			pass_step(val) {
				if (val == '1') {
					this.show_step_btn = true;
				} else {
					this.show_step_btn = false;
				}
			},
			isFileMain(val) {
				if (val == '1') {
					this.show_FileMain = true;
					this.show_FileChildren = false;
				} else {
					this.show_FileMain = false;
					this.show_FileChildren = true;
				}
			}

		},
		mounted: function() {
			this.load_data();

			// const that = this;
			// // 滚动事件 scroll
			// // 变形事件 resize
			// window.addEventListener('scroll', function() {
			// 	that.chang_style(); //fixed 行相对位置修正
			// }, false);
			// // 这里只是操作dom
			// window.addEventListener('resize', function() {
			// 	that.chang_style(); //fixed 行相对位置修正
			// }, false);

		},
		methods: {
			chang_style: function() {
				this.$nextTick(function() {

					let css = '',
						tw = 0;
					css = 'width: ' + tw + 'px;max-width: ' + tw + 'px;';

					var t = document.getElementById('big_order_body');
					console.log(t);
					try {
						if (t == null) {
							// alert('11');
						} else {
							document.getElementById('pre_tab').style.cssText = css;
						}
					} catch (e) {}

				});
			},
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d, type) {
				console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}
				if (type == 'save') {
					this.fun_upd('_add');
				}
				this.load_order_d(d);
			},
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			CheckRN(str) {
				let t = '';
				t = str;
				let reg = new RegExp('\r\n', 'g');
				t = t.replace(reg, '<br/>')
				return t;
			},
			load_order_d: function(d) {
				console.log('点击=' + d.key + ' name=' + d.name);
				let isshow_d_edit_str = '';
				isshow_d_edit_str = this.show_edit_str;
				if (isshow_d_edit_str.indexOf(d.key) >= 0) {

					this.list_child_detail = [];
					this.element_loading = true;
					this.$post(
						api.http_method,
						Sel_page_and_length('exp_cw_look_order_d', 1, 999, this.order_no, d.key)
					).then(res => {
						this.element_loading = false;
						try {
							res = JSON.parse(res);

							if (res.length > 0) {
								this.list_child_detail = res[0];

								// this.$refs.orderdetail.showpop()
								this.show_order_detail = true;
								console.log('订单详情', this.list_child_detail);
							} else {
								this.$message({
									message: '订单:' + this.child_sheet_no + ' 没有查询到相关数据!',
									type: 'success'
								});
							}
						} catch (ex) {
							this.$message({
								message: "查询失败" + ex,
								type: 'warning'
							});
						}
					});

				} else {
					// this.$refs.orderdetail.closeshow()
					this.show_order_detail = false;
				}
			},
			show_edit: function() {
				console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_tan_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_tan_bg").fadeIn("3000");
					$(".pre_auto_conten").fadeIn("3000");

				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_auto_conten").fadeOut("3000");


				this.show_tan = false;
				this.show_child_d = false;

				// this.$refs.listsheet.closeshow();
				this.show_sheet_list = false;
				this.show_sheetone = false;

				// 关闭窗口 应该更新编辑信息？=》如果发生编辑 =》才应该进行更新
				// 保证 编辑后清空 全部查询
				// for (let i = 0; i < this.parm_sel.length; i++) {
				//   this.parm_sel[i].val = '';
				// }

				this.load_db_data();
				// this.$emit('base2-event', 'father');
			},
			closeorderdetail: function() {
				this.show_order_detail = false;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {

				// 初始化最大行数
				this.max_row = [];
				for (let i = 1; i < 20; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}
				let edit_str = '';
				edit_str +=
					'etc_pay,etc_xj,oil_start,oil_pay,oil_money,ns_pay,ns_money,etc_start,xj_start,'
				edit_str += 'fk_pay,tcf_pay,wh_pay,dache_pay,zhusu_pay,day_pay,glf_pay,qt_pay,'
				edit_str += 'dz_amount,dy_amount,zc_amount,xc_amount,zengbu,'
				edit_str += 'hs_pay,bz_pay,df_pay,xx_pay,ys_qt_pay,yc_amount,yc_day,';
				edit_str += 'bx_amount,kl_pay,back_sheet,jw_pay,' //特殊处理

				this.show_edit_str = '';
				this.show_edit_str = edit_str;

				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.edit_flag = '';
				this.check_key = '';


				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_size = '0';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else {
						this.parm[j].val = '';
					}
				}

				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}

				let udata = GetShort('userdata');
				let rname = '';
				if (typeof(udata) !== 'undefined' && udata != '') {
					let r = JSON.parse(udata);
					rname = r[0].rname;
				}
				console.log('当前角色:' + rname);
				let is_look = 'none';
				if (rname == 'admin' || rname == 'caiwu') {
					is_look = 'text';
				}

				this.tab_data = {};

				this.tab_data = {
					"control": "order_all",
					"sel_action": 'exp_cw_transpass_ph',
					"upd_action": '_cw_tr_hispass',
					"parm_sel": [{
							"name": "订单号",
							"val": "",
							"key": "order_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "厂家名称",
							"val": "",
							"key": "c_id",
							"type": "text",
							"p": "1",
							"w": "0",
							"r": "0",
							"sel": "2"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "4"
						},
						{
							"name": "调度单",
							"val": "",
							"key": "sheet_ys",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "6"
						}
					],
					"parm": [
						{
							"name": "订单号",
							"val": "",
							"key": "order_no",
							"type": "text",
							"r": '1',
							"class": "long1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "订单类型",
							"val": "",
							"key": "order_type",
							"type": "text",
							"r": '1',
							"class": "long1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "综合名称",
							"val": "",
							"key": "item_up_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": '0'
						},
						{
							"name": "总吨位",
							"val": "",
							"key": "item_up_weight",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": '1'
						},
						{
							"name": "厂家名称",
							"val": "",
							"key": "c_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_company",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "2",
							"r": '0'
						},
						{
							"name": "终点",
							"val": "",
							"key": "e_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "2",
							"r": '0'
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1 ",
							"p": "1",
							"x": "2",
							"r": '0'
						},
						{
							"name": "结束日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1 ",
							"p": "1",
							"x": "2",
							"r": '0'
						},
						{
							"name": "总距离",
							"val": "",
							"key": "sj_dis",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "2",
							"r": '0'
						},

						{
							"name": "罚款",
							"val": "",
							"key": "fk_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},
						{
							"name": "停车费",
							"val": "",
							"key": "tcf_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},

						{
							"name": "维修费",
							"val": "",
							"key": "wh_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},
						{
							"name": "打车费",
							"val": "",
							"key": "dache_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},
						{
							"name": "住宿费",
							"val": "",
							"key": "zhusu_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},
						{
							"name": "生活费",
							"val": "",
							"key": "day_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "3"
						},
						{
							"name": "过路费",
							"val": "",
							"key": "glf_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "ETC现金",
							"val": "",
							"key": "etc_xj",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "现金购油",
							"val": "",
							"key": "oil_money",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "现金购尿素",
							"val": "",
							"key": "ns_money",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "司机其他",
							"val": "",
							"key": "qt_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "司机合计",
							"val": "",
							"key": "driver_amount",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "4"
						},
						{
							"name": "ETC消费",
							"val": "",
							"key": "etc_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},

						{
							"name": "ETC合计",
							"val": "",
							"key": "etc_all",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},
						{
							"name": "油卡消费",
							"val": "",
							"key": "oil_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},
						{
							"name": "油卡合计",
							"val": "",
							"key": "oil_all",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},
						{
							"name": "油卡购尿素",
							"val": "",
							"key": "ns_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},

						{
							"name": "尿素合计",
							"val": "",
							"key": "ns_all",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "5"
						},
						{
							"name": "ETC期初",
							"val": "",
							"key": "etc_start",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "6"
						},
						{
							"name": "现金期初",
							"val": "",
							"key": "xj_start",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "6"
						},
						{
							"name": "现金剩余",
							"val": "",
							"key": "last_xj",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "6"
						},
						{
							"name": "油卡期初",
							"val": "",
							"key": "oil_start",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "6"
						},
						{
							"name": "油卡剩余",
							"val": "",
							"key": "last_y",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "6"
						},

						{
							"name": "护送费",
							"val": "",
							"key": "hs_pay",
							"type": "number",
							"class": "long1",
							"p": "0",
							"x": "7",
							"r": '1'
						},

						{
							"name": "办证费",
							"val": "",
							"key": "bz_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "7"
						},
						{
							"name": "公司垫付",
							"val": "",
							"key": "df_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "7"
						},
						{
							"name": "信息费",
							"val": "",
							"key": "xx_pay",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "7"
						},
						// {
						// 	"name": "吊装费",
						// 	"val": "",
						// 	"key": "dz_amount",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "7"
						// },
						// {
						// 	"name": "倒运费",
						// 	"val": "",
						// 	"key": "dy_amount",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "7"
						// },
						// {
						// 	"name": "装车费",
						// 	"val": "",
						// 	"key": "zc_amount",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "7"
						// },
						// {
						// 	"name": "卸车费",
						// 	"val": "",
						// 	"key": "xc_amount",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "7"
						// },
						// {
						// 	"name": "就位费",
						// 	"val": "",
						// 	"key": "jw_pay",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "7"
						// },
						// {
						// 	"name": "押车费",
						// 	"val": "",
						// 	"key": "yc_amount",
						// 	"type": "number",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"x": "7",
						// 	"r": '1'
						// },
						// {
						// 	"name": "押车天数",
						// 	"val": "",
						// 	"key": "yc_day",
						// 	"type": "number",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"x": "7",
						// 	"r": '1'
						// },

						{
							"name": "运输其他",
							"val": "",
							"key": "ys_qt_pay",
							"type": "number",
							"class": "long1",
							"p": "0",
							"x": "7",
							"r": '1'
						},
						{
							"name": "运输合计",
							"val": "",
							"key": "amount_out",
							"type": "number",
							"class": "long1",
							"p": "0",
							"x": "7",
							"r": '1'
						},

						{
							"name": "运费",
							"val": "",
							"key": "yf_amount",
							"type": "number",
							"class": "long1",
							"p": "0",
							"r": "1",
							"x": "8"
						},
						{
							"name": "油卡",
							"val": "",
							"key": "oil_card",
							"type": "number",
							"class": "long1",
							"p": "0",
							"r": "1",
							"x": "8"
						},
						{
							"name": "回单",
							"val": "",
							"key": "back_sheet",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "8"
						},
						{
							"name": "保险费",
							"val": "",
							"key": "bx_amount",
							"type": "number",
							"class": "long1",
							"p": "0",
							"x": "8",
							"r": '1'
						},
						{
							"name": "看路费",
							"val": "",
							"key": "kl_pay",
							"type": "number",
							"class": "long1",
							"p": "0",
							"x": "8",
							"r": '1'
						},
						{
							"name": "配货费",
							"val": "",
							"key": "ph_amount",
							"type": "number",
							"class": "long1",
							"r": '1',
							"x": "8"
						},



						{
							"name": "中标价",
							"val": "",
							"key": "zhongbiao",
							"type": "none",
							"class": "long1",
							"p": "1",
							"r": '0',
							"x": "9"
						},
						{
							"name": "增补费",
							"val": "",
							"key": "zengbu",
							"type": "none",
							"class": "long1",
							"p": "1",
							"r": '1',
							"x": "9"
						},
						{
							"name": "开票",
							"val": "",
							"key": "kaipiao",
							"type": "none",
							"class": "long1",
							"r": '1',
							"x": "9"
						},
						{
							"name": "总利润",
							"val": "",
							"key": "amount_ok",
							"type": is_look,
							"r": '1',
							"class": "long1",
							"x": "10"
						},
						{
							"name": "天数",
							"val": "",
							"key": "day_all",
							"type": "text",
							"r": '1',
							"class": "long1",
							"x": "10"
						},
						// {
						// 	"name": "利润元/天",
						// 	"val": "",
						// 	"key": "day_ok",
						// 	"type": "text",
						// 	"r": '1',
						// 	"class": "long1",
						// 	"x": "13"
						// },
						// {
						// 	"name": "剩余油箱格数",
						// 	"val": "",
						// 	"key": "last_oil_sj",
						// 	"type": "number",
						// 	"class": "long1",
						// 	"weight": "1",
						// 	"p": "1",
						// 	"x": "14"
						// },
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "11"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "订单号"
						},
						{
							"name": "订单类型"
						},
						{
							"name": "综合名称"
						},
						{
							"name": "总吨位"
						},
						{
							"name": "厂家"
						},
						{
							"name": "状态"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "总距离"
						},
						{
							"name": "罚款"
						},
						{
							"name": "停车费"
						},

						{
							"name": "维修费"
						},
						{
							"name": "打车费"
						},

						{
							"name": "住宿费"
						},
						{
							"name": "生活费"
						},
						{
							"name": "过路费"
						},
						{
							"name": "ETC现金消费"
						},
						{
							"name": "现金购油"
						},
						{
							"name": "现金购尿素"
						},
						{
							"name": "其他费用"
						},
						{
							"name": "司机消费合计"
						},

						{
							"name": "ETC卡消费"
						},
						{
							"name": "ETC合计"
						},
						{
							"name": "油卡消费"
						},
						{
							"name": "油卡合计"
						},
						{
							"name": "油卡购尿素"
						},
						{
							"name": "尿素合计"
						},
						{
							"name": "ETC支付"
						},
						{
							"name": "现金期初"
						},
						{
							"name": "现金剩余"
						},
						{
							"name": "油卡期初"
						},
						{
							"name": "油卡剩余"
						},
						{
							"name": "护送费"
						},
						{
							"name": "办证费"
						},
						{
							"name": "公司垫付"
						},
						{
							"name": "信息费"
						},
						{
							"name": "吊装费"
						},
						{
							"name": "倒运费"
						},
						{
							"name": "装车费"
						},
						{
							"name": "卸车费"
						},
						{
							"name": "押车费"
						},
						{
							"name": "押车天数"
						},
						{
							"name": "就位费"
						},
						{
							"name": "运输其他费"
						},
						{
							"name": "运输合计"
						},

						{
							"name": "总运费"
						},
						{
							"name": "总油卡"
						},
						{
							"name": "回单"
						},
						{
							"name": "保险费"
						},
						{
							"name": "看路费"
						},
						{
							"name": "配货费"
						},

						{
							"name": "中标价"
						},
						{
							"name": "增补费用"
						},
						{
							"name": "开票"
						},

						{
							"name": "总利润"
						},
						{
							"name": "天数"
						},
						// {
						// 	"name": "剩余油箱格数"
						// },
						{
							"name": "备注"
						},
						{
							"name": "审核人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_sel_action": 'exp_tr_his_d',
					"d_upd_action": 'tr_his_pass_d',
					"file_action": 'tr_exp_pay',
					"p1": '',
					"p2": '',
					"p3": '',
					"d_parm": [{
							"name": "运单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"r": "0"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "tb_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"r": "1"
						},
						{
							"name": "费用字段",
							"val": "",
							"key": "tb_key",
							"type": "none",
							"class": "long1",
							"p": "1",
							"r": "0"
						},
						{
							"name": "金额",
							"val": "",
							"key": "tb_val",
							"type": "number",
							"class": "long1",
							"p": "1",
							"r": "0"
						},
						{
							"name": "支付日期",
							"val": "",
							"key": "tb_date",
							"type": "date",
							"class": "long1 ",
							"p": "1",
							"r": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"r": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "支付日期"
						},
						{
							"name": "类型"
						},
						{
							"name": "卡号"
						},
						{
							"name": "流水状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "备注"
						},
						{
							"name": "更新时间"
						}
					]

				};

				// console.log('初始数据', this.tab_data);

				let r = this.tab_data;
				// console.log(r);

				this.title = r.title;
				this.control = r.control;
				this.pass_step = r.step; //判断是否有业务流程
				this.isFileMain = r.isFileMain; //附件保存在主单据 | 还是明细
				// console.log('pass_step=' + this.pass_step);

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				// this.edit_flag = r.upd_action.substring(0, 5);
				this.check_key = r.check_key;
				// console.log('编辑标识=' + this.edit_flag);

				this.file_action = r.file_action;
				this.p1 = r.p1;
				this.p2 = r.p2;
				this.p3 = r.p3;

				this.parm_sel = r.parm_sel;
				this.parm = r.parm;
				this.parm_th = r.parm_th;
				// console.log('查询', this.parm_sel);
				// console.log('参数结构', this.parm);

				this.detail_part = r.detail_part;

				if (this.detail_part == '1') {
					this.d_sel_action = r.d_sel_action;
					this.d_upd_action = r.d_upd_action;
					this.d_parm = r.d_parm;
					this.d_name = r.d_name;
					this.d_detail = [];

					if (r.d_btn_more == '1') {
						this.d_btn_more = true;
					}

					if (r.d_btn_del == '0') {
						this.d_btn_del = false;
					}

					// 给明细增加导入功能
					if (r.detail_excelup == '1') {
						this.detail_excelup = true;
					}
				}
				console.log('明细结构:', this.d_parm)

				if (typeof(r.isTwo) != "undefined" && r.isTwo != '') {
					this.isTwo = r.isTwo;
				}

				if (typeof(r.isTwoDetail) != "undefined" && r.isTwoDetail != '') {
					this.isTwoDetail = r.isTwoDetail;
				}

				this.list_child_d = [];
				this.list_child_d = [{
						"name": "运单",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"r": '1',
						"class": "long1",
						"p": "1",
						"x": "1"
					},
					{
						"name": "订单号",
						"val": "",
						"key": "order_no",
						"type": "text",
						"r": '1',
						"class": "long1",
						"p": "1",
						"x": "1"
					},
					{
						"name": "货名",
						"val": "",
						"key": "d_name",
						"type": "text",
						"r": '1',
						"class": "long1",
						"p": "1",
						"x": "1"
					},

					{
						"name": "车牌",
						"val": "",
						"key": "car_no",
						"type": "text",
						"class": "long1",
						"p": "0",
						"x": "1",
						"r": '1'
					},
					{
						"name": "车挂",
						"val": "",
						"key": "car_gua",
						"type": "text",
						"class": "long1",
						"p": "0",
						"x": "1",
						"r": '1'
					},
					{
						"name": "司机",
						"val": "",
						"key": "driver",
						"type": "text",
						"class": "long1",
						"p": "0",
						"x": "1",
						"r": '1'
					},
					{
						"name": "电话",
						"val": "",
						"key": "phone",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "1",
						"r": '1'
					},
					{
						"name": "厂家",
						"val": "",
						"key": "c_name",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": '1'
					},
					{
						"name": "起点",
						"val": "",
						"key": "s_addr",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": '1'
					}, {
						"name": "终点",
						"val": "",
						"key": "e_addr",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": '1'
					}, {
						"name": "开始日期",
						"val": "",
						"key": "s_date",
						"type": "date",
						"class": "long1 ",
						"p": "1",
						"x": "2",
						"r": '1'
					}, {
						"name": "结束日期",
						"val": "",
						"key": "e_date",
						"type": "date",
						"class": "long1 ",
						"p": "1",
						"x": "2",
						"r": '1'
					}, {
						"name": "总距离",
						"val": "",
						"key": "sj_dis",
						"type": "number",
						"class": "long1",
						"p": "1",
						"x": "2",
						"r": '1'
					},

					{
						"name": "罚款",
						"val": "",
						"key": "fk_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},
					{
						"name": "停车费",
						"val": "",
						"key": "tcf_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},

					{
						"name": "维修费",
						"val": "",
						"key": "wh_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},
					{
						"name": "打车费",
						"val": "",
						"key": "dache_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},
					{
						"name": "住宿费",
						"val": "",
						"key": "zhusu_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},
					{
						"name": "生活费",
						"val": "",
						"key": "day_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "3"
					},
					{
						"name": "过路费",
						"val": "",
						"key": "glf_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "ETC现金",
						"val": "",
						"key": "etc_xj",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "现金购油",
						"val": "",
						"key": "oil_money",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "现金购尿素",
						"val": "",
						"key": "ns_money",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "司机其他",
						"val": "",
						"key": "qt_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "司机合计",
						"val": "",
						"key": "driver_amount",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "4"
					},
					{
						"name": "ETC消费",
						"val": "",
						"key": "etc_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},

					{
						"name": "ETC合计",
						"val": "",
						"key": "etc_all",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},
					{
						"name": "油卡消费",
						"val": "",
						"key": "oil_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},
					{
						"name": "油卡合计",
						"val": "",
						"key": "oil_all",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},
					{
						"name": "油卡购尿素",
						"val": "",
						"key": "ns_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},

					{
						"name": "尿素合计",
						"val": "",
						"key": "ns_all",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "5"
					},

					{
						"name": "ETC支付",
						"val": "",
						"key": "etc_start",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "6"
					},
					{
						"name": "现金支付",
						"val": "",
						"key": "xj_start",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "6"
					},
					{
						"name": "现金剩余",
						"val": "",
						"key": "last_xj",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "6"
					},
					{
						"name": "油卡剩余",
						"val": "",
						"key": "oil_start",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "6"
					},
					{
						"name": "油卡剩余",
						"val": "",
						"key": "last_y",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "6"
					},

					{
						"name": "护送费",
						"val": "",
						"key": "hs_pay",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "7",
						"r": '1'
					},

					{
						"name": "办证费",
						"val": "",
						"key": "bz_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "公司垫付",
						"val": "",
						"key": "df_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "信息费",
						"val": "",
						"key": "xx_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "吊装费",
						"val": "",
						"key": "dz_amount",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "倒运费",
						"val": "",
						"key": "dy_amount",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "装车费",
						"val": "",
						"key": "zc_amount",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "卸车费",
						"val": "",
						"key": "xc_amount",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "就位费",
						"val": "",
						"key": "jw_pay",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "7"
					},
					{
						"name": "押车费",
						"val": "",
						"key": "yc_amount",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "7",
						"r": '1'
					},
					{
						"name": "押车天数",
						"val": "",
						"key": "yc_day",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "7",
						"r": '1'
					},

					{
						"name": "运输其他",
						"val": "",
						"key": "ys_qt_pay",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "7",
						"r": '1'
					},
					{
						"name": "运输合计",
						"val": "",
						"key": "amount_out",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "7",
						"r": '1'
					},

					{
						"name": "运费",
						"val": "",
						"key": "yf_amount",
						"type": "number",
						"class": "long1",
						"p": "0",
						"r": "1",
						"x": "8"
					},
					{
						"name": "油卡",
						"val": "",
						"key": "oil_card",
						"type": "number",
						"class": "long1",
						"p": "0",
						"r": "1",
						"x": "8"
					},
					{
						"name": "回单",
						"val": "",
						"key": "back_sheet",
						"type": "text",
						"r": '1',
						"class": "long1",
						"x": "8"
					},
					{
						"name": "保险费",
						"val": "",
						"key": "bx_amount",
						"type": "number",
						"class": "long1",
						"p": "0",
						"x": "8",
						"r": '1'
					},
					{
						"name": "配货费",
						"val": "",
						"key": "ph_amount",
						"type": "number",
						"class": "long1",
						"r": '1',
						"x": "8"
					},



					{
						"name": "中标价",
						"val": "",
						"key": "zhongbiao",
						"type": "number",
						"class": "long1",
						"p": "1",
						"r": '0',
						"x": "9"
					},
					{
						"name": "增补费",
						"val": "",
						"key": "zengbu",
						"type": "number",
						"class": "long1",
						"p": "1",
						"r": '1',
						"x": "9"
					},
					{
						"name": "开票",
						"val": "",
						"key": "kaipiao",
						"type": "number",
						"class": "long1",
						"r": '1',
						"x": "9"
					},
					{
						"name": "总利润",
						"val": "",
						"key": "amount_ok",
						"type": is_look,
						"r": '1',
						"class": "long1",
						"x": "10"
					},
					// {
					// 	"name": "天数",
					// 	"val": "",
					// 	"key": "day_all",
					// 	"type": "text",
					// 	"r": '1',
					// 	"class": "long1",
					// 	"x": "10"
					// },
					// {
					// 	"name": "利润元/天",
					// 	"val": "",
					// 	"key": "day_ok",
					// 	"type": "text",
					// 	"r": '1',
					// 	"class": "long1",
					// 	"x": "13"
					// },
					// {
					// 	"name": "剩余油箱格数",
					// 	"val": "",
					// 	"key": "last_oil_sj",
					// 	"type": "number",
					// 	"class": "long1",
					// 	"weight": "1",
					// 	"p": "1",
					// 	"x": "14"
					// },
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"x": "11"
					}


				];
				this.load_db_data();
			},
			select_method: function(type) {
				// console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw3 = dateFormatbyChina(this.kw3);
							}
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw4 = dateFormatbyChina(this.kw4);
							}
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
						case '10':
							this.kw10 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that
						.kw10, r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE' || type == 'UPDATE_OK') {
					this.page_length = pagelength;
					this.nowpage = page;
					this.load_db_data();
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					if (this.sheet_flag.indexOf('提交成功') >= 0) {
						this.show_btn = false;
					} else {
						this.show_btn = true;
					}

					if (this.sheet_flag.indexOf('删除成功') == 0) {
						this.closeshow();
						return;
					}
				}

				// 通过明细刷新主单信息,再刷新子信息
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
						'', '', '',
						'', '', '', '', '', r)
				).then(res => {
					res = JSON.parse(res);

					this.element_loading = false;
					let res_page = [];
					res_page = res[0][0];

					if (res_page.flag == 1) {
						let bd = [];
						// console.log('allcount='+res_page.all_count)
						if (res_page.all_count > 0) {
							let t_list_data = res[1];
							// console.log(t_list_data);
							for (let i = 0; i < t_list_data.length; i++) {
								let arr = [];
								for (let j in t_list_data[i]) {
									let o = {};
									o.key = j;
									let temp_str = '';
									temp_str = t_list_data[i][j];
									if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
										temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
										temp_str = ReplaceAll(temp_str, '\n', "<br/>");
										temp_str = temp_str.replace("\\r\\n", "\r\n");
										temp_str = temp_str.replace("\\n", "\n");
									}
									o.val = temp_str;
									arr.push(o);
								}
								bd.push(arr);
							}
						}

						this.sel_row(bd[0], 'edit');
						console.log('刷新明细=' + this.d_sel_action);
						if (typeof(this.d_sel_action) != 'undefined' && this.d_sel_action != '') {
							this.fun_d_load();
						}

					} else {
						this.$message({
							message: '编辑数据更新失败! \r\n ' + res.data.msg,
							type: 'success'
						});
					}

				});



				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			excelup_detail: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelupdetail'].show_edit();
				});
			},
			new_blank: function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.d_detail = [];

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					this.parm[j].val = '';
				}

				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				this.show_order_detail = false;

				// 双击打开界面,如果有明细,应该查询
				// console.log(this.d_upd_action);
				if (this.detail_part == '1') {
					this.d_row_id = '';
					this.d_sys_date = ''; //备份点击项目

					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].type != 'select') {
							this.d_parm[j].val = '';
						} else {
							this.d_parm[j].val = '';
							this.d_parm[j].sel_name = '';
							this.d_parm[j].sel_val = {};
						}
					}
				}

				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.fun_d_load();
				}
				this.show_edit();

			},
			sel_row: function(item, type) {
				// console.log('选择', item);
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							if (this.sheet_flag == '盘点完成') {
								this.show_btn = false;
								this.show_btn_ok = true;
							} else {
								this.show_btn = true;
								this.show_btn_ok = false;
							}
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						case 'order_no':
							this.order_no = item[i].val;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}
				// console.log(this.parm)

				// 多附件时生效
				if (this.file_list_main.length > 0) {
					this.file_name = '';
					this.file_url = '';
					this.file_src = '';
					for (let i = 0; i < this.file_list_main.length; i++) {
						if (this.file_list_main[i].sheet_id == this.row_id) {
							this.file_name = BackSpecial(this.file_list_main[i].file_name);
							this.file_url = BackSpecial(this.file_list_main[i].file_url);
							this.file_src = BackSpecial(this.file_list_main[i].file_src);
						}
					}

					if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
						this.file_show = false;
					} else {
						this.file_show = true;
					}
				}

				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[0].val);
				}
				
				
			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}



				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				// console.log('===END============')
			},
			fun_upd: async function(type) {
				console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].w == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							let str_sel = this.parm[i].val;
							console.log(typeof(str_sel));
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}

				// if (this.edit_flag == 'base_') {
				// 	this.fun_edit_base(type);
				// } else {
				// 	this.fun_edit_other(type);
				// }
				let d = [];
				d.push('');
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}
				console.log('传参', d);
				let r = (Math.random() + '').substring(0, 8);
				this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d, r);

			},
			fun_edit_base: function(type) {
				// console.log('通用编辑方法 ID=' + this.row_id + ' sys_date=' + this.sys_date);
				let d = '';
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						// add 2022-02-15 必须强制删除所有特殊符号，特别是^
						let temp_val = '',
							temp_key = '',
							temp_type = '';
						temp_key = this.parm[i].key;
						temp_val = this.parm[i].val;

						d = d + temp_key + '=' + Word_Right_Delete(temp_val) + '^';
					}
				}
				// console.log(d);
				d = d.slice(0, -1);

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_TableAll(this.upd_action + type, this.check_key, this.row_id, this.sys_date, d,
					r);
			},
			fun_edit_other: function(type) {
				// console.log('自定义编辑方法');
				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				switch (this.edit_flag) {
					case 'exp15':
						this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
							r);
						break;
					case 'exp30':
						this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date,
							d, r);
						break;
					case 'exp50':
						this.upd_json = Method_CommonLongLong('data_' + this.upd_action + type, this.row_id, this
							.sys_date, d, r);
						break;
				}
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					// temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerText = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			/****单据 弹窗  编辑 start*****************************************/
			look_list_sheetm: function() {
				console.log('order_no=' + this.order_no);

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length('exp_cw_look_order_to_sheet', 1, 999, this.order_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						console.log('调度单', res);
						if (res.length > 0) {
							this.list_sheet_m = res[0];

							// this.$refs.listsheet.showpop();

							this.show_sheet_list = true;


						} else {
							this.$message({
								message: '订单:' + this.order_no + ' 没有查询到相关调度单数据!',
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			closeshowsheetm: function() {
				// this.$refs.listsheet.closeshow();
				this.show_child_d = false;
				this.show_sheet_list = false;
				this.show_child_d = false;
			},
			fun_sel_sheetno: function(item) {
				console.log('选择单号', item);
				let key = 'sheet_m_';
				for (var i = 0; i < this.list_sheet_m.length; i++) {
					if (this.list_sheet_m[i].row_num == item.row_num) {
						document.getElementById(key + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_sheet_m[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_sheet_m[i].row_num).style.background = '#fff';
						} else {
							document.getElementById(key + this.list_sheet_m[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
				this.child_sheet_no = '';
				this.child_sheet_no = item.sheet_no;
				// this.show_child_d = false;
				for (let i = 0; i < this.list_child_d.length; i++) {
					this.list_child_d[i].val = '';
				}
				this.load_child_d();
			},
			load_child_d: function() {
				console.log('加载单项调度单信息')
				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length('exp_cw_look_child_sheet', 1, 999, this.child_sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						console.log('调度单详情', res);
						if (res.length > 0) {
							let t = res[0][0];
							// console.log(t);

							for (let d in t) {
								// console.log(d + '=' + t[d]);
								for (let i = 0; i < this.list_child_d.length; i++) {
									if (this.list_child_d[i].key == d) {

										this.list_child_d[i].val = t[d];
										break;
									}
								}
							}

							this.show_child_d = true;
						} else {
							this.$message({
								message: '调度单:' + this.child_sheet_no + ' 没有查询到相关数据!',
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});
			},
			check_sheetm: function(type) {
				console.log('检索运单=' + this.child_sheet_no);

				this.element_loading = true;
				let d = [];
				d.push(this.child_sheet_no)
				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method,
					Method_Common('_cw_look_child_sheet' + type, 0, '', d, r)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						console.log('检查结果', res);
						if (res.length > 0) {
							let t = res[0][0];
							// console.log(t);

						} else {
							this.$message({
								message: '调度单:' + this.child_sheet_no + ' 没有查询到相关数据!',
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});

			},
			closeshowchildd: function() {
				this.show_child_d = false;
			},
			refresh_view_child: function(d) {
				console.log('点击=' + d.key + ' name=' + d.name);
				let isshow_d_edit_str = '';
				isshow_d_edit_str = this.show_edit_str;
				if (isshow_d_edit_str.indexOf(d.key) >= 0) {

					this.list_child_detail = [];
					this.element_loading = true;
					this.$post(
						api.http_method,
						Sel_page_and_length('exp_cw_look_child_detail', 1, 999, this.child_sheet_no, d.key)
					).then(res => {
						this.element_loading = false;
						try {
							res = JSON.parse(res);
							// console.log('调度单详情', res);
							if (res.length > 0) {
								this.list_child_detail = res[0];
								this.show_child_detail = true;
								console.log('调度单详情', this.list_child_detail);
							} else {
								this.$message({
									message: '调度单:' + this.child_sheet_no + ' 没有查询到相关数据!',
									type: 'success'
								});
							}
						} catch (ex) {
							this.$message({
								message: "查询失败" + ex,
								type: 'warning'
							});
						}
					});

				} else {
					this.show_child_detail = false;
				}
			},
			closeshowchilddetail: function() {
				this.show_child_detail = false;
			},
			/****单据 弹窗  编辑 end*****************************************/
			/****明细部分操作 start***********************************************/
			check_d_parm: function() {
				// console.log('sheet_no=' + this.sheet_no);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == 'sheet_no') {
						this.sheet_no = this.parm[i].val;
						break;
					}
				}
				// console.log('sheet_no=' + this.sheet_no);
				let nosheet_no = true;
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no') {
						this.d_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'm_id') {
							this.d_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.d_parm.length; i++) {
						if (that.d_parm[i].weight == '1' && that.d_parm[i].val == '') {
							that.$message({
								message: that.title + '明细: ' + that.d_parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}
			},
			fun_d_upd: function(item) {
				// console.log('编辑', item);

				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:

							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].key == item[i].key) {
							if (this.d_parm[j].type == 'select' || this.d_parm[j].type == 'radio') {
								this.d_parm[j].val = '';
								this.d_parm[j].sel_name = item[i].val;
							} else {
								this.d_parm[j].val = item[i].val;
							}
						}
					}
				}

				// this.setActiveRowBackColor('d', item[0].val, 'detail');
			},
			fun_d_edit: function(type, item) {
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}
				this.fun_d_save(type);
			},
			fun_d_del: function(type, item) {
				let flag = true;
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'f_url':
							if (item[i].val != '') {
								flag = false;
							}
							break;
						default:
							break;
					}
				}
				if (flag) {
					this.fun_d_save(type);
				} else {
					this.$message({
						message: '请先删除附件,再删除数据!',
						type: 'warning'
					});
				}
			},
			fun_d_load: function() {
				// 加载明细数据
				console.log('加载明细数据=' + this.sheet_no);
				this.d_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					this.$message({
						message: '明细数据单号未匹配到,请刷新重试或联系开发人员!',
						type: 'warning'
					});
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						// console.log('明细查询', res);
						if (res.length > 0) {

							let t = res[0];
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// console.log('key=' + j);       //输出key
									// console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								this.d_detail.push(arr);
							}



						} else {
							this.$message({
								message: '业务单号:' + this.sheet_no + ' 没有查询到明细数据!',
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});


			},
			fun_d_save: async function(type) {
				if (type == '_del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let flag = false;
					flag = await this.check_d_parm();
					if (flag) {
						return;
					}
				}

				if (type == '_upd' || type == '_sub' || type == '_bad') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}
				// console.log('待检结构', this.d_parm);

				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].p == '1') {
						let temp = '';
						if (this.d_parm[i].type == 'time' || this.d_parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.d_parm[i].val);
						} else if (this.d_parm[i].type == 'selectnew') {
							// console.log(this.d_parm[i].key + '下拉选项', this.d_parm[i])
							if (typeof(this.d_parm[i].val) === 'number' && Number(this.d_parm[i].val) > 0) {
								temp = this.d_parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.d_parm[i].list.length; j++) {
									if (this.d_parm[i].list[j].val == this.d_parm[i].sel_name) {
										temp = this.d_parm[i].list[j].id;
									}
								}
							}

						} else if (this.d_parm[i].type == 'select') {
							// console.log(this.d_parm[i].key + '下拉选项', this.d_parm[i])
							if (typeof(this.d_parm[i].val) === 'number' && Number(this.d_parm[i].val) > 0) {
								temp = this.d_parm[i].val;
							} else {
								temp = '0';
								let t_action = this.d_parm[i].sel_action;
								let res = await this.loadClass(t_action);
								console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.d_parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.d_parm[i].val;
						}

						this.d_parm[i].val = temp;
					}
				}

				// console.log('编辑结构', this.d_parm);



				let d = [];
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].p == '1') {
						d.push(this.d_parm[i].val);
					}
				}
				// console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common('data_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							// document.getElementById('isfirst').focus();
							this.refresh_data();

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			/****明细部分操作 end***********************************************/
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.sel_action, this.nowpage, this.page_length, this.kw1,
							this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10
						)
					});

					this.show_excel = true;
				}
			},
			setActiveRowBackColor: function(key, id, type) {
				console.log('key=' + key + ' id=' + id + ' type=' + type);
				key = key + '_';
				switch (type) {
					case 'detail':
						for (var i = 0; i < this.d_detail.length; i++) {
							// console.log(this.d_detail[i]);
							if (this.d_detail[i][0].val == id) {
								document.getElementById(key + id).style.background = '#92a4f3';
							} else {
								if (this.d_detail[i][0].val % 2 == 0) {
									document.getElementById(key + this.d_detail[i][0].val).style.background = '#fff';
								} else {
									document.getElementById(key + this.d_detail[i][0].val).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
					case 'main':
						break;
				}
			},
			//附件操作 start //////////////////////////////////////
			fun_show_detail: function(t) {
				console.log(t);
				this.file_url = '';
				this.file_src = '';
				this.file_url = decodeURI(t.f_url);
				this.file_src = decodeURI(t.f_src);
				let tt = BackSpecial(this.file_url);
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				this.fun_look_file();
			},
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_data = '';
				this.file_backdata = '';
				if (this.isFileMain == '1') {
					if (this.row_id == null || Number(this.row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
						});
						return;
					}
				} else {
					if (this.d_row_id == null || Number(this.d_row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 明细项目名称</div>请检查!'
						});
						return;
					}
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				let fileobj = document.getElementById('hetong_file');

				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();

			},
			fun_look_file: function() {
				console.log('点击预览附件');
				// console.log(this.parm);
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_src == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + this.file_action + '_del","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.row_id +
						'"}';
				} else {
					postdata =
						'{"action":"' + this.file_action + '_del","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.d_row_id +
						'"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// //console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					if (this.isFileMain == '0') {
						that.fun_d_load();
					} else {
						this.load_db_data();
					}

				});

			},
			fun_del_file_three: function() {
				console.log('删除路径 \r\n' + this.file_src);

				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

						this.file_name = '';
						this.file_url = '';
						this.file_src = '';
						this.file_data = '';
						this.file_backdata = '';
						this.file_show = false;

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {

					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// //console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// //console.log('上传长度=' + temp_data.size);
					// //console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						//console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// 这里保存文件数据。因为是切片追加模式，而且不写路径。所以row_id和sheet_no 不用传
				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_size":"' +
						this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.sheet_no + '","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';
				} else {
					postdata =
						'{"action":"data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_size":"' +
						this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.sheet_no + '","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';

				}

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// //console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// //console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				//console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				if (this.isFileMain == '1') {
					postdata =
						'{"action":"_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.row_id + '"}';
				} else {
					postdata =
						'{"action":"_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.d_row_id + '"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						if (this.isFileMain == '1') {
							that.load_db_data()
						} else {
							that.fun_d_load();
						}


						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_table_detail_new {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_table_detail_new td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header_new td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_table_detail_new tr td:nth-child(1) {
		display: none;
	}

	.pre_table_detail_new tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	.pre_table_detail_new tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_table_detail_new td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_table_detail_new td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_table_detail_new td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_table_detail_new td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_table_detail_new tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_table_detail_new tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_table_detail_new tr:hover {
		background-color: #b8f8b8 !important;
	}

	/*  .pre_table_detail_new tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_table_detail_new tr>td>a:focus {
		background: #92a4f3 !important;
	}


	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}


	.pre_auto_conten {
		position: fixed;
		width: 98%;
		height: auto;
		left: 1%;
		top: 8%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 80%;
		z-index: 30;
		overflow-y: auto;
		overflow-x: hidden;

	}

	.pre_auto_sheet_m {
		/* position: fixed; */
		width: 84%;
		height: auto;
		left: 2%;
		top: 28%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 33;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 6px;
		box-shadow: 0 0 5px 5px #818181;

	}

	.pre_auto_child_d {
		position: fixed;
		/* width: 80%; */
		height: auto;
		/* right: 10%; */
		top: 16%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 34;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 6px;
		box-shadow: 0 0 5px 5px #818181;
	}

	.pre_auto_sheet_detail {
		position: fixed;
		/* width: 98%; */
		height: auto;
		left: 2%;
		top: 50%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 36;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 6px;
		box-shadow: 0 0 5px 5px #818181;

	}

	.pre_auto_order_d {
		/* position: fixed; */
		width: auto;
		height: auto;
		left: 2%;
		top: 28%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 33;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 6px;
		box-shadow: 0 0 5px 5px #818181;

	}



	/* 设置 倒数 第二、第三列 隐藏 */
	/* .last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.dlast-two-none>td:nth-last-child(4),
	.dlast-two-none>td:nth-last-child(3) {
		display: none;
	}
 */



	.trans_edit {
		/* min-width: 1600px; */
		max-height: 80%;
		overflow-y: auto;
	}

	.tab-item {
		/* margin: 0px; */

		/* margin-top: 2px; */
		/* min-width: 256px; */
		margin-right: 10px;
		padding-top: 2px;
		padding-bottom: 2px;
		/*  border-bottom: 1px solid #0000ff;  */
		/* border-left: 1px solid #0000ff; */
		/* border-right: 1px solid #0000ff; */
	}



	.col-item {
		display: inline-block;
		min-width: 254px;
		width: 254px;
		max-width: 254px;
		vertical-align: top;
	}

	.col-top {
		margin-top: 37px;
	}

	.col-item .content_edit_item input {
		text-align: left;
	}


	.pre_leve_one {
		margin: 0px;
	}

	.content_edit_item label {
		display: inline-block;
		min-width: 96px;
	}


	.tab-row {
		display: block;
		overflow: auto;
	}

	.tab-row>div>div>label {
		min-width: 1200px;
	}

	.big-order-body>div:nth-child(3),
	.big-order-body>div:nth-child(4) {
		background-color: #d0d0d0;
	}

	.big-order-body>div:nth-child(6) {
		background-color: #86c5ff;
	}

	.big-order-body>div:nth-child(8) {
		background-color: #86c5ff;
	}

	.child-sheet-no {
		/* min-width: 1400px; */
		top: 24%;
		/* left: 200px; */

	}

	.pre_upload {
		display: flex;
		flex-direction: column;
	}
</style>
